import React, { useEffect, useCallback } from 'react';
import { HiXMark, HiChevronLeft, HiChevronRight } from 'react-icons/hi2';
import './Lightbox.css';

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  const handleKey = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    else if (e.key === 'ArrowLeft') onPrev();
    else if (e.key === 'ArrowRight') onNext();
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [handleKey]);

  if (index === null || index < 0 || !images[index]) return null;

  const current = images[index];

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox__close" onClick={onClose} aria-label="Close">
        <HiXMark />
      </button>

      <button
        className="lightbox__nav lightbox__nav--prev"
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        aria-label="Previous"
      >
        <HiChevronLeft />
      </button>

      <div className="lightbox__content" onClick={(e) => e.stopPropagation()}>
        <img src={current.url} alt="Screenshot" className="lightbox__img" />
      </div>

      <button
        className="lightbox__nav lightbox__nav--next"
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        aria-label="Next"
      >
        <HiChevronRight />
      </button>

      <div className="lightbox__counter">
        {index + 1} / {images.length}
      </div>
    </div>
  );
}
